import { ComponentProps, CSSProperties, FC } from "react";
import { useTranslation } from "react-i18next";
import { Flex, TextLink } from "shared/components/Spor";
import { FCWC } from "shared/utils/FCWC";
import { useTheme } from "styled-components";

export const contactItHref =
  "mailto:team-brukerflater-drops@vy.no?cc=vygruppen@service-now.com";
export const contactItLinkTarget = "_blank";
export const contactItLinkRel = "noopener noreferrer";

export const openContactIt = () => {
  void window.open(contactItHref, contactItLinkTarget, "noopener,noreferrer");
};

type StateContainerProps = Pick<
  ComponentProps<typeof Flex>,
  "backgroundColor" | "minHeight" | "gap" | "padding"
> & {
  border?: boolean;
};

export const StateContainer: FCWC<StateContainerProps> = ({
  children,
  backgroundColor = "semantics.colorBackgroundSecondary",
  minHeight,
  gap,
  padding,
  border = false,
}) => {
  const theme = useTheme();

  return (
    <Flex
      width="100%"
      flex="1"
      flexDir="column"
      alignItems="center"
      justifyContent="center"
      minHeight={minHeight}
      p={padding}
      backgroundColor={backgroundColor}
      gap={gap}
      borderRadius="6px"
      border={border ? `1px solid ${theme.colorOutlineSecondary}` : undefined}
    >
      {children}
    </Flex>
  );
};

type ContactItLinkProps = {
  translationKey: "Kontakt IT" | "ta kontakt med IT";
  style?: CSSProperties;
};

export const ContactItLink: FC<ContactItLinkProps> = ({
  translationKey,
  style,
}) => {
  const { t } = useTranslation();

  return (
    <TextLink
      href={contactItHref}
      target={contactItLinkTarget}
      rel={contactItLinkRel}
      style={style}
    >
      {t(translationKey)}
    </TextLink>
  );
};
